import { render } from "./RegisterMobilePopup.vue?vue&type=template&id=4971eecc&scoped=true"
import script from "./RegisterMobilePopup.vue?vue&type=script&lang=js"
export * from "./RegisterMobilePopup.vue?vue&type=script&lang=js"

import "./RegisterMobilePopup.vue?vue&type=style&index=0&id=4971eecc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4971eecc"]])

export default __exports__